export default {
  currency: 'currency',
  numeric: 'numeric',
  number: '9,999,999',
  date: '99/99/9999'
};
//# sourceMappingURL=form-masks.js.map